import CaseStudyRepositories from "@repositories/case-studies.repositories"
import { Result } from "@lib/api/services/result"
import { CaseStudy, CaseStudySummary } from "@interfaces/case-study"
import { Testimony } from "@interfaces/testimony"

export default class CaseStudyServices extends CaseStudyRepositories {
  async getCaseStudiesList() {
    try {
      const res = await this.getRawCaseStudyList()

      const { error, result } = await this._getResponse<CaseStudy[]>(res)

      if (error || !result) {
        return Result.fail<CaseStudy[]>()
      }

      const project = result.map((p) => {
        return this._swaggerResponseSpreader<any>(p)
      })

      const projectData = project.map((d) => {
        return {
          ...d,
          caseStudySummarries: d.caseStudySummarries
            ? this._swaggerDataSpreader<CaseStudySummary>(d.caseStudySummarries)
            : [],
          testimony: this._swaggerResponseSpreader<Testimony>(d?.testimony?.data),
        }
      })

      return Result.ok<CaseStudy[]>(projectData)
    } catch (e) {
      return Result.fail<CaseStudy[]>()
    }
  }

  async getCaseStudyDetail(id: string) {
    try {
      const res = await this.getRawCaseStudyDetail(id)

      const { error, result } = await this._getResponse<any>(res)

      if (error || !result) {
        return Result.fail<CaseStudy>()
      }

      const project = this._swaggerResponseSpreader<any>(result)

      const caseStudy = {
        ...project,
        caseStudySummarries: project.caseStudySummarries
          ? this._swaggerDataSpreader<CaseStudySummary>(project.caseStudySummarries)
          : [],
        testimony: this._swaggerResponseSpreader<Testimony>(project?.testimony?.data),
      }

      return Result.ok<CaseStudy>(caseStudy)
    } catch (e) {
      console.log({ e })
      return Result.fail<CaseStudy>()
    }
  }
}
